import React, { useRef } from 'react';
import { X, Maximize } from 'lucide-react';
import Carousel from '../Shared/Carousel.tsx';
import ModalOverlay from '../../../UI/ModalOverlay/ModalOverlay.tsx';
import styles from './IdentityModal.module.scss';

interface IdentityModalProps {
  user: any;
  onClose: () => void;
}

const IdentityModal: React.FC<IdentityModalProps> = ({ user, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleFullscreen = () => {
    if (modalRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        modalRef.current.requestFullscreen();
      }
    }
  };

  return (
    <ModalOverlay isOpen={true} onClose={onClose} zIndex={1000}>
      <div className={styles.modal} ref={modalRef}>
        <div className={styles.modalContent}>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={20} />
          </button>
          
          <h2 className={styles.title}>
            {user.jobBoard.name} - Documentos de Identidad
          </h2>
          
          <Carousel
            items={[
              { image: user.dni_front, legend: 'DNI Frontal' },
              { image: user.dni_back, legend: 'DNI Reverso' },
              { image: user.selfie, legend: 'Selfie' }
            ]}
          />

          <button className={styles.fullscreenButton} onClick={handleFullscreen}>
            <Maximize size={16} />
            Pantalla completa
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default IdentityModal;

